// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.right_fot[data-v-3d6890b4]{\n        text-align: center;margin-top: 100px;color: #707070;\n        font-size: 14px;margin-left: 300px;\n}\n.left[data-v-3d6890b4]{\n        margin-right: 100px;\n}\n.right[data-v-3d6890b4]{\n}\n", ""]);
// Exports
module.exports = exports;
